var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-linkedin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Media",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flueid-Desktop-Media-Story-1",
    transform: "translate(-386.000000, -500.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(301.000000, 493.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-linkedin",
    transform: "translate(85.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.02910714,18 L0.297321429,18 L0.297321429,5.98232101 L4.02910714,5.98232101 L4.02910714,18 Z M2.16120536,4.3429987 C0.967901786,4.3429987 0,3.35458378 0,2.16125357 C0,0.967626178 0.96760461,0 2.16120536,0 C3.3548061,0 4.32241071,0.967626178 4.32241071,2.16125357 C4.32241071,3.35458378 3.35410714,4.3429987 2.16120536,4.3429987 Z M17.9959821,18 L14.2722321,18 L14.2722321,12.1498694 C14.2722321,10.7556419 14.2441071,8.96765551 12.3320089,8.96765551 C10.3917857,8.96765551 10.0944643,10.4824215 10.0944643,12.0494207 L10.0944643,18 L6.36669643,18 L6.36669643,5.98232101 L9.94580357,5.98232101 L9.94580357,7.62164332 L9.99803571,7.62164332 C10.49625,6.67742582 11.7132589,5.680975 13.5289286,5.680975 C17.3057143,5.680975 18,8.16808409 18,11.3985133 L18,18 L17.9959821,18 Z",
    id: "Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/icon-linkedin.79453619e4f56849d40714b8f3c3234d.svg";
export { ForwardRef as ReactComponent };